var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMazeWithoutMentorship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 344,
    viewBox: "0 0 337 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_1539_no)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 337,
    transform: "translate(337 1.47307e-05) rotate(90)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5 230L290.5 200.5L260 200.5M260 200.5L260 172M260 200.5L198.5 200.5M198.5 200.5L198.5 262.5L226.5 262.5M198.5 200.5L198.5 171.25M198.5 142L198.5 171.25M198.5 171.25L136.5 171.25M74.5 171.25L74.5 140L74.5 200.5M47 200.5L74.5 200.5L74.5 171.25M74.5 171.25L105.5 171.25M136.5 171.25L136.5 230.5L104.5 230.5M136.5 171.25L105.5 171.25M104.5 230.5L104.5 203.5M104.5 230.5L104.5 262.5M104.5 262.5L74.5 262.5L74.5 290.5M104.5 262.5L104.5 293.5L135.5 293.5L135.5 324M135.5 324L164.5 324M135.5 324L43.5 324M43.5 324L43.5 267M43.5 324L13 324L13 230.5M13 230.5L71.5 230.5M13 230.5L13 107.5M13 107.5L42.25 107.5M13 107.5L13 45.5M71.5 107.5L42.25 107.5M42.25 107.5L42.25 165.5M13 45.5L42.25 45.5M13 45.5L13 14.5L136.5 14.5L136.5 45.5M136.5 74L136.5 45.5M136.5 45.5L107 45.5M105.5 171.25L105.5 107.5M105.5 107.5L134 107.5M105.5 107.5L105.5 77.5L74 77.5M47 77.5L74 77.5M74 77.5L74 47",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5 15L322 15L322 325L198.5 325L198.5 293L167.5 293L167.5 202",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5 293L227 293",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 325L260 230.5L231.5 230.5",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 262L288.5 262",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 293L292 293",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 170L290 170L290 139L229 139L229 110.5L229 166",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 139L290 108L262 108",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5 262L138.5 262",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5 15L260.5 45.5L288 45.5",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 15L197.5 46.5L167.5 46.5L167.5 108L197.5 108L197.5 77.5L288.5 77.5",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5 108L167.5 139L138.5 139",
    stroke: "#94A3B8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 77.5L229 47",
    stroke: "#94A3B8",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_1539_no"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 337,
    fill: "white",
    transform: "translate(337 1.47307e-05) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMazeWithoutMentorship);
export default __webpack_public_path__ + "static/media/maze-without-mentorship.b9ef06850bece5e6065c9039c4c46ebe.svg";
export { ForwardRef as ReactComponent };